<div  class="success" *ngIf="result == 'success'">

  <div *ngFor="let ord of orderNumbers">
    <h1>Заказ №{{ord}} успешно создан</h1>
  </div>

  <div class="text-info">Детали заказа отправлены на почту. <br/> Если письмо не пришло, проверьте папку спам.</div>
</div>

<div  class="cancel" *ngIf="result == 'cancel'">

  <h1>Не удалось оплатить заказ.</h1>

</div>
